import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Preferences } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	taxiServiceIds: [],
};

const setTaxiServiceIds: ReduxReducer<State, State["taxiServiceIds"]> = (
	state,
	{ payload },
) => {
	state.taxiServiceIds = payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const filters = createSlice({
	name: Preferences.ConstantPreferencesSlice.CAR_CLASSES_FILTERS,
	initialState,
	reducers: {
		reset,
		setTaxiServiceIds,
	},
});

export const filtersAction = filters.actions;
export const filtersReducer = filters.reducer;
export type filtersState = State;

export default filters;
